import { useCallback, useEffect, useState } from 'react'
import { Backdrop, CircularProgress, Grid, makeStyles, TextField } from '@material-ui/core'
import { validateEmptyField, validateEmail } from '../../common/validations'
import SaveOrCancelButtons from '../../components/saveOrCancelButtons'
import { updateProviderData } from '../../api/providers.service'
import { providerDataKeyNames, providerRequiredField } from './provider.data.keys'
import { getInputValue } from '../../common/utils'
import { toast } from 'react-toastify'
import { DialogTitle } from '../../components/DialogTitle'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}))

const MyDataForm = (props) => {
  const classes = useStyles()

  const providerData = props.providerData
  const handleClose = props.onClose

  const formTitle = 'Editar Mis Datos'

  const [loading, setLoading] = useState(false)

  const [stateForm, setStateForm] = useState({})

  const [stateErrorForm, setStateErrorForm] = useState({
    ...providerRequiredField,
    email2: '',
    email3: '',
    email4: '',
    paymentEmail: ''
  })

  const getData = useCallback(() => {
    setLoading(true)
    let data = {}
    for (const key in providerData) {
      if (Object.hasOwnProperty.call(providerData, key)) {
        const element = providerData[key]
        data[key] = element === null ? '' : element
      }
    }
    setStateForm(data)
    setLoading(false)
  }, [providerData])

  useEffect(() => {
    if (providerData !== undefined && providerData !== null) {
      getData()
    }
  }, [providerData, getData])

  const handleInputChange = (event) => {
    const value = getInputValue(event.target)
    const name = event.target.name

    setStateErrorForm({
      ...stateErrorForm,
      [name]: ''
    })

    setStateForm({
      ...stateForm,
      [name]: value
    })
  }

  const validateForm = () => {
    let hasError = false
    let listError = {}
    for (const key in stateErrorForm) {
      if (Object.hasOwnProperty.call(stateForm, key)) {
        const value = stateForm[key]
        let error = ''

        if (key.includes('mail') && value !== '') error = validateEmail(value) ?? ''
        else if (Object.hasOwnProperty.call(providerRequiredField, key))
          error = validateEmptyField(value) ?? ''

        if (!hasError) hasError = !!error

        listError[key] = error
      }
    }
    setStateErrorForm({
      ...stateErrorForm,
      ...listError
    })
    return !hasError
  }

  const handleUpdate = () => {
    if (!validateForm()) return
    setLoading(true)

    let data = Object.entries(stateForm)
      .map((item) => ({
        [item[0]]: {
          name: providerDataKeyNames[item[0]],
          value: stateForm[item[0]]
        }
      }))
      .reduce((previous, current) => Object.assign(previous, current), { providerId: stateForm.id })

    updateProviderData(JSON.stringify(data))
      .then(() => toast.success('Datos enviados a Conway'))
      .finally(() => {
        setLoading(false)
        handleClose()
      })
  }

  const Title = (_) => <h2>{formTitle}</h2>

  return (
    <div>
      <Grid container spacing={2}>
        <DialogTitle title={<Title />} />

        {Object.entries(stateForm)
          .filter((entry) => entry[0] !== 'id')
          .map((entry) => {
            if (providerDataKeyNames[entry[0]]) {
              return (
                <Grid key={`provider-data-form-${entry[0]}`} item xs={12} sm={6} md={4}>
                  <TextField
                    type="text"
                    label={providerDataKeyNames[entry[0]]}
                    name={entry[0]}
                    fullWidth
                    value={stateForm[entry[0]]}
                    required={providerRequiredField[entry[0]] !== undefined}
                    helperText={stateErrorForm[entry[0]]}
                    error={
                      stateErrorForm[entry[0]] !== '' && stateErrorForm[entry[0]] !== undefined
                    }
                    onChange={handleInputChange}
                  />
                </Grid>
              )
            }
            return ''
          })}

        <SaveOrCancelButtons onSave={handleUpdate} onCancel={handleClose} loading={loading} />
      </Grid>
      <Backdrop className={classes.backdrop} open={loading} onClick={handleClose}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  )
}

export default MyDataForm
